import React from "react";
import { useTranslation } from "react-i18next";
import { setLocale } from "../i18n";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "./ui/dropdown-menu";

/**
 * Compact language switcher used in the public header and as a tab in /account.
 */
export default function LanguageSwitcher({ variant = "icon" }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language || "es-AR";

  const change = (lng) => {
    if (lng !== current) setLocale(lng);
  };

  if (variant === "tabs") {
    return (
      <div className="flex gap-2" data-testid="lang-switcher-tabs">
        {[
          { code: "es-AR", label: t("lang.es_AR") },
          { code: "en", label: t("lang.en") },
        ].map((o) => (
          <button
            key={o.code}
            onClick={() => change(o.code)}
            className={`px-3 py-1.5 rounded-sm border text-xs font-mono uppercase tracking-wider transition ${
              current === o.code
                ? "bg-foreground text-background border-foreground"
                : "border-border text-muted-foreground hover:text-foreground"
            }`}
            data-testid={`lang-${o.code}`}
          >
            {o.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="h-8 px-2 flex items-center gap-1.5 rounded-sm border border-border bg-card hover:bg-muted text-xs font-mono"
        data-testid="lang-switcher"
      >
        <Globe className="h-3.5 w-3.5" />
        {current === "en" ? "EN" : "ES"}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => change("es-AR")} data-testid="lang-opt-es">
          🇦🇷 {t("lang.es_AR")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => change("en")} data-testid="lang-opt-en">
          🇺🇸 {t("lang.en")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
